<template>
  <div>
    <Page404 v-if="!providedFeaturesPaymentMethod" />
    <section v-else class="p-box">
      <div class="p-box__body">
        <Loading v-if="loading" />
        <template v-else>
          <section class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title">
                {{ $t('models.storePaymentMethod.modelName') }}
              </h3>
            </header>
            <div class="p-box__body">
              <KkInfo icon="hint">
                {{ $t('pages.CompaniesLocationStorePaymentMethodsEdit.description') }}
              </KkInfo>
              <div class="paymentMethods">
                <PaymentMethods
                  :payment-methods="paymentMethods"
                  @change-attributes="paymentMethodsReducer"
                />
              </div>
            </div>
          </section>
          <GmbProtection
            v-model="gmbLocationSynced.payment_method_synced"
            :title="$t('pages.CompaniesLocationStore.gmbProtection.edit.title', { value: $t('models.storePaymentMethod.modelName') })"
          />
          <KkPreviewModal
            :is-visible="showPreview"
            :title="$t('pages.CompaniesLocationStorePaymentMethodsEdit.preview.title')"
            :show-submit="true"
            :loading="paymentMethodsPreviewLoading"
            :payment-method="paymentMethods"
            :payment-method-synced="gmbLocationSynced.payment_method_synced"
            :payment-method-preview="paymentMethodsPreview"
            @close="showPreview=false"
            @submit="handleSubmit"
          />
        </template>
      </div>
      <footer class="p-box__footer">
        <div class="c-button c-button--right">
          <router-link :to="{ name: 'CompaniesLocationStore', params: { company_uuid: companyUuid, store_uuid: storeUuid }}" class="c-button__item c-button__item--outline-cancel">
            {{ $t('labels.cancel') }}
          </router-link>
          <button class="c-button__item c-button__item--primary" :disabled="loading" @click="handleShowPreview">
            {{ $t('labels.save') }}
          </button>
        </div>
      </footer>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Loading from '../components/Loading.vue'
import GmbProtection from '../components/CompaniesLocationStore/GmbProtection.vue'
import PaymentMethods from '../components/PaymentMethods'
import { KkInfo } from '../components/ui'
import { KkPreviewModal } from '../domains/paymentMethod'
import Page404 from '../views/Page404'

export default {
  name: 'CompaniesStorePaymentMethodEdit',
  components: {
    Loading,
    GmbProtection,
    PaymentMethods,
    KkInfo,
    KkPreviewModal,
    Page404,
  },
  emits: ['update-title'],
  data () {
    return {
      companyUuid: this.$route.params.company_uuid,
      storeUuid: this.$route.params.store_uuid,
      showPreview: false
    }
  },
  computed: {
    ...mapState({
      paymentMethods: state => state.companiesStorePaymentMethods.data,
      paymentMethodsLoading: state => state.companiesStorePaymentMethods.loading,
      paymentMethodsPreview: state => state.companiesStorePaymentMethods.preview,
      paymentMethodsPreviewLoading: state => state.companiesStorePaymentMethods.previewLoading,
      storeGmb: state => state.companiesStoreGmb.data,
      storeGmbConnected: state => state.companiesStoreGmb.connected,
      storeGmbLoading: state => state.companiesStoreGmb.loading,
    }),
    ...mapGetters({
      gmbLocationSynced: 'companiesStoreGmb/gmbLocationSynced',
      providedFeaturesPaymentMethod: 'companiesCompany/providedFeaturesPaymentMethod',
    }),
    loading() {
      return this.paymentMethodsLoading || this.storeGmbLoading
    },
    submitParams() {
      return {
        store_credit_card: this.paymentMethods.creditCard,
        store_electronic_money: this.paymentMethods.electronicMoney,
        store_transportation_electronic_money: this.paymentMethods.transportationElectronicMoney,
        store_qr_code_payment: this.paymentMethods.qrCodePayment,
        store_cash_only: this.paymentMethods.cashOnly,
        store_pay_check: this.paymentMethods.payCheck,
        store_debit_card: this.paymentMethods.debitCard,
      }
    }
  },
  async created() {
    await Promise.all([
      this.readStorePaymentMethods({ company_uuid: this.companyUuid, store_uuid: this.storeUuid }),
      this.readStoreGmb({ company_uuid: this.companyUuid, store_uuid: this.storeUuid }),
    ])
    this.$emit(
      'update-title',
      this.$t('pages.CompaniesLocationStorePaymentMethodsEdit.title', {
        name: this.storeGmb.attributes.store_name
      })
    )
  },
  methods: {
    ...mapActions({
      readStorePaymentMethods: 'companiesStorePaymentMethods/readStorePaymentMethods',
      updatePaymentMethods: 'companiesStorePaymentMethods/updatePaymentMethods',
      paymentMethodsReducer: 'companiesStorePaymentMethods/reducer',
      readStoreGmb: 'companiesStoreGmb/readStoreGmb',
      createStorePaymentMethodsPreview: 'companiesStorePaymentMethods/createStorePaymentMethodsPreview',
    }),
    async handleSubmit() {
      const isSuccess = await this.updatePaymentMethods({ company_uuid: this.companyUuid, store_uuid: this.storeUuid, params: this.submitParams, synced: this.gmbLocationSynced.payment_method_synced })
      this.showPreview = false
      if(isSuccess) this.$router.push({ name: 'CompaniesLocationStore', params: { company_uuid: this.companyUuid, store_uuid: this.storeUuid }})
    },

    async handleShowPreview() {
      this.showPreview = true
      this.createStorePaymentMethodsPreview({ companyUuid: this.companyUuid, storeUuid: this.storeUuid, params: this.submitParams })
    },
  }
}
</script>

<style lang="scss" scoped>
.protection {
  padding-top: 32px;
}
.paymentMethods {
  width: 596px;
  max-width: 100%;
}
</style>
